import React from 'react'

interface DocNotesProps {
  notes?: string | string[]
}

const DocNotes: React.FC<DocNotesProps> = ({ notes }) => {
  const notesStr = Array.isArray(notes) ? notes.join('\n') : (notes ?? '')
  const noteLines = notesStr.split('\n').filter((line) => line.trim() !== '') // Remove any empty lines

  return (
    <div className="mb-4 print:mb-[0.5em] text-base">
      <span className="text-xl print:text-[1.2em] font-bold text-gray-700 uppercase">Observaciones</span>
      {noteLines.length > 0 ? (
        noteLines.map((line, index) => (
          <div key={line + '-' + index} className="mt-2 print:mt-[0.3em] text-gray-800">
            {line}
          </div>
        ))
      ) : (
        <div className="mt-2 print:mt-[0.3em] text-gray-500 italic">No se registran observaciones.</div>
      )}
    </div>
  )
}

export default DocNotes
